import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import {getQueryParams} from '../../services/UtilityService';
import PodcastService from '../../services/PodcastService';
import PodcastNotes from './PodcastNotes';

const PodcastPdf = () => {
	const location = useLocation();
	const params = getQueryParams(location.search);
    const podcast = PodcastService.getPodcastData(params);

	const renderContent = () => {
		if (!podcast) {
			return null;
		}

		return <PodcastNotes podcast={podcast} />;
	};

	return (
		<>
			<Helmet>
				<meta charSet='UTF-8' />
				<meta name='viewport' content='width=device-width, initial-scale=1.0' />
				<meta httpEquiv='X-UA-Compatible' content='ie=edge' />
				<link rel='stylesheet' href='/report/pdf.css' />
				<title>The 6 Types of Working Genius Podcast Pdf</title>
			</Helmet>
			{renderContent()}
		</>
	);
};

export default PodcastPdf;
